import { object, string, number, SchemaOf } from 'yup';

import { Location } from '@components/LocationSearch/LocationSearch';

export const locationSchema: SchemaOf<Location> = object({
  address: string().default('').notRequired(),
  latitude: number().default(0).notRequired(),
  longitude: number().default(0).notRequired(),
});
